import React from "react";
import Button from "../../../components/Button";
import Header from "../../../components/Header";
import UtilImage from "../../../assets/hero-util1.png";

const Hero = () => {
  return (
    <div className=" min-h-screen md:min-h-[120vh] hero relative">
      <div className="">
        <Header />
        <div className="text-center pt-36">
          <h1 className="text-center text-4xl sm:text-7xl leading-[4rem] md:leading-[6rem] mb-6">
            Welcome to <br />
            <b>Kings Coin</b>
          </h1>
          <Button
            center
            link
            href={
              "https://app.uniswap.org/#/swap?outputCurrency=0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"
            }
          >
            Buy Kings Coin
          </Button>
        </div>
      </div>
      <img
        src={UtilImage}
        alt=""
        className="absolute bottom-0 z-10 left-1/2 -translate-x-1/2"
      />
    </div>
  );
};

export default Hero;
